// Prompts stored on a waste receiver use {{placeholder}} markers that the backend
// substitutes before the LLM call. The setup editor highlights them so an admin can see at
// a glance which parts of a prompt are filled in dynamically.
//
// A placeholder never contains a brace itself, so an unclosed `{{` simply does not match
// rather than swallowing the rest of the prompt.
const PLACEHOLDER_SOURCE = '\\{\\{[^{}]*\\}\\}';

export function tokenizePromptPlaceholders(prompt) {
    const text = typeof prompt === 'string' ? prompt : '';
    // A fresh regex per call: a shared /g literal would carry `lastIndex` between calls.
    const pattern = new RegExp(PLACEHOLDER_SOURCE, 'g');
    const tokens = [];
    let lastIndex = 0;
    let match = pattern.exec(text);

    while (match) {
        if (match.index > lastIndex) {
            tokens.push({ type: 'text', value: text.slice(lastIndex, match.index) });
        }
        tokens.push({ type: 'placeholder', value: match[0] });
        lastIndex = match.index + match[0].length;
        match = pattern.exec(text);
    }

    if (lastIndex < text.length) {
        tokens.push({ type: 'text', value: text.slice(lastIndex) });
    }

    return tokens;
}

export function listPromptPlaceholders(prompt) {
    const seen = new Set();

    return tokenizePromptPlaceholders(prompt)
        .filter((token) => token.type === 'placeholder')
        .map((token) => token.value)
        .filter((placeholder) => {
            if (seen.has(placeholder)) return false;
            seen.add(placeholder);
            return true;
        });
}
